import { Link } from "react-router-dom";
import { ProToolCard } from "@/features/tools/ProToolCard";
import {
  toolPageMetadata,
  toolPageOrder,
} from "@/features/tools/toolMetadata";
import { useProToolPageData } from "@/features/tools/useProToolPageData";

export function ProTools() {
  const { tools, canUseProTools, isLoading, error } = useProToolPageData();

  return (
    <div className="w-full max-w-full space-y-8">
      <section className="min-w-0 rounded-lg border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
        <p className="text-sm font-semibold text-indigo-700">Pro Tools</p>
        <h2 className="mt-2 break-words text-2xl font-semibold tracking-normal text-slate-950">
          Your commercial planning suite
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600">
          Move from blueprint to launch-ready with three expert tools — powered
          by your saved blueprints. Check readiness, model monetisation, and
          generate sales-page headlines in minutes.
        </p>
      </section>

      {error ? (
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          {error}
        </div>
      ) : null}

      {isLoading ? (
        <div className="grid min-w-0 gap-4 lg:grid-cols-3">
          {[0, 1, 2].map((item) => (
            <div
              key={item}
              className="h-52 animate-pulse rounded-lg border border-slate-200 bg-white"
            />
          ))}
        </div>
      ) : (
        <div className="grid min-w-0 gap-4 lg:grid-cols-3">
          {toolPageOrder.map((toolType) => {
            const tool = tools.find(
              (catalogTool) => catalogTool.toolType === toolType,
            );
            const metadata = toolPageMetadata[toolType];

            if (!tool) {
              return null;
            }

            return (
              <ProToolCard
                key={tool.toolType}
                tool={tool}
                href={canUseProTools ? metadata.route : undefined}
                benefit={metadata.benefit}
              />
            );
          })}
        </div>
      )}

      {!isLoading && !canUseProTools ? (
        <section className="min-w-0 rounded-lg border border-indigo-200 bg-indigo-50 p-4 sm:p-6">
          <p className="text-sm font-semibold text-indigo-950">
            Unlock your commercial planning suite with Pro.
          </p>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-indigo-900">
            Pro includes the Launch Readiness Checker, Monetisation Model
            Suggester, and Sales Page Headline Generator — all powered by your
            saved blueprints.
          </p>
          <Link
            to="/pricing"
            className="mt-5 inline-flex rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700"
          >
            Upgrade to Pro
          </Link>
        </section>
      ) : null}
    </div>
  );
}
